import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from "@angular/router";
import { StorageService } from "../app/services/storage.service";
import { ToastrService } from 'ngx-toastr';


@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(
    private toastr: ToastrService,
    private router: Router,
    private storageService: StorageService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!request.params.has('hiddenProgressBar')) {
      if (document.getElementById('progressBar') != null) {
        document.getElementById('progressBar').style.visibility = 'visible';
      }
    }

    var session = JSON.parse(localStorage.getItem('currentUser'));

    if (session != null && session.token) {
      request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + session.token) });
    }

    /** Cuando es multipart, no hay que poner cabeceras */
    if (!request.headers.has('Content-Type') && !request.params.has('multipart')) {
      request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
    }

    request = request.clone({ headers: request.headers.set('Access-Control-Allow-Origin', '*') });

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {

          document.getElementById('progressBar').style.visibility = 'hidden';
        }
        return event;
      }),
      catchError((error: any) => {
        // Ocultar progressBar primero para asegurar que se ejecuta
        const progressBar = document.getElementById('progressBar');
        if (progressBar) {
          progressBar.style.visibility = 'hidden';
        }

        // Manejar 401 (Unauthorized) primero y redirigir sin mostrar toastr
        if (error instanceof HttpErrorResponse && error.status === 401) {
          this.storageService.removeCurrentSession();
          this.router.navigate(['/login']);
          return throwError(error);
        }

        // Mostrar mensaje de error
        const errorMessage = error?.error?.message || 'Error en la petición';

        // El error 417 es para excepciones de negocio (warnings/advertencias)
        // intentamos mostrar toast normales, no estos
        // if (error.status === 417) {
        //   this.toastr.error(errorMessage, "Se ha producido un error");
        // }

        return throwError(error);
      }));
  }
}

